module.exports = __webpack_public_path__ + "img/iconPlans.51dba626.png";